import { useState, useEffect } from 'react';
import { loadGeoJSON, loadTouchpointData, processCountyData, getAvailableYears, getTouchpointTypes, processStateData } from '../utils/dataLoader';

// hook to load all dashboard data
export const useData = () => {
  const [geoData, setGeoData] = useState(null);
  const [touchpointData, setTouchpointData] = useState(null);
  const [countyData, setCountyData] = useState(null);
  const [years, setYears] = useState([]);
  const [touchpointTypes, setTouchpointTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [stateData, setStateData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        const [geo, touchpoints] = await Promise.all([
          loadGeoJSON(),
          loadTouchpointData()
        ]);

        setGeoData(geo);
        setTouchpointData(touchpoints);

        const processed = processCountyData(touchpoints);
        setCountyData(processed);

        const processedState = processStateData(touchpoints);
        setStateData(processedState);   

        const availableYears = getAvailableYears(touchpoints);
        const types = getTouchpointTypes(touchpoints);

        setYears(availableYears);
        setTouchpointTypes(types);

        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return {
    geoData,
    touchpointData,
    countyData,
    stateData,
    years,
    touchpointTypes,
    loading,
    error
  };
};
